import { useState } from 'react';
import Toggle from './Toggle';
import { resizeImage } from './util';

const ROLES = ['set principal', 'closing', 'apertura'];

export default function CreateEventModal({ api, onClose, onCreated }) {
  const [f, setF] = useState({
    name: '', date: '', start_time: '', end_time: '', venue: '',
    flyer_url: null, published: false,
  });
  const [lineup, setLineup] = useState([]);
  const [saving, setSaving] = useState(false);
  const [err, setErr] = useState('');
  const set = (k, v) => setF(s => ({ ...s, [k]: v }));

  const onFlyer = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    try {
      const dataUrl = await resizeImage(file, 1200, 0.8);
      set('flyer_url', dataUrl);
    } catch (err) {
      alert(err.message || 'No se pudo procesar la imagen');
    }
  };

  const addDj = () => setLineup(l => [...l, { name: '', role: 'set principal', time: '' }]);
  const setDj = (i, k, v) => setLineup(l => l.map((r, j) => j === i ? { ...r, [k]: v } : r));
  const rmDj = (i) => setLineup(l => l.filter((_, j) => j !== i));

  async function save() {
    if (!f.name.trim()) { setErr('El nombre es obligatorio'); return; }
    setSaving(true); setErr('');
    try {
      const time = [f.start_time, f.end_time].filter(Boolean).join(' — ');
      const ev = await api.post('/api/events', {
        name: f.name.toUpperCase(),
        date: f.date || null,
        start_time: f.start_time,
        end_time: f.end_time,
        venue: f.venue,
        flyer_url: f.flyer_url,
        published: f.published,
        status: f.published ? 'proxima' : 'proxima',
        lineup: lineup.filter(r => r.name.trim()).map(r => [r.name, r.role, r.time]),
      });
      onCreated(ev);
    } catch (e) {
      setErr(e.message);
    } finally {
      setSaving(false);
    }
  }

  return (
    <div className="lb-modal-backdrop" onClick={onClose}>
      <div className="lb-modal lb-modal--wide" onClick={e => e.stopPropagation()}>
        <div style={{ padding: '24px 28px', borderBottom: '1px solid rgba(255,255,255,0.08)', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <div>
            <div className="lb-eyebrow">Nuevo evento</div>
            <div className="lb-h" style={{ fontSize: 22, marginTop: 4 }}>{f.name || 'SIN NOMBRE'}</div>
          </div>
          <button className="lb-iconbtn" onClick={onClose}>✕</button>
        </div>

        <div style={{ padding: '24px 28px', display: 'grid', gridTemplateColumns: '1.3fr 1fr', gap: 28 }}>
          <div style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
            <Field label="Nombre del evento">
              <input className="lb-input" value={f.name} onChange={e => set('name', e.target.value)} placeholder="LA MANADA VUELVE." />
            </Field>
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: 12 }}>
              <Field label="Fecha"><input className="lb-input" type="date" value={f.date} onChange={e => set('date', e.target.value)} /></Field>
              <Field label="Inicio"><input className="lb-input" type="time" value={f.start_time} onChange={e => set('start_time', e.target.value)} /></Field>
              <Field label="Fin"><input className="lb-input" type="time" value={f.end_time} onChange={e => set('end_time', e.target.value)} /></Field>
            </div>
            <Field label="Lugar">
              <input className="lb-input" value={f.venue} onChange={e => set('venue', e.target.value)} placeholder="Ej: nombre y dirección del lugar" />
            </Field>

            {/* lineup */}
            <div>
              <div className="lb-label" style={{ marginBottom: 10 }}>DJ set · Lineup</div>
              <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
                {lineup.map((row, i) => (
                  <div key={i} style={{ display: 'grid', gridTemplateColumns: '1.4fr 1fr 0.7fr auto', gap: 8 }}>
                    <input className="lb-input" style={{ padding: '10px 12px', fontSize: 13 }} placeholder="DJ / Artista" value={row.name} onChange={e => setDj(i, 'name', e.target.value)} />
                    <select className="lb-select" style={{ padding: '10px 12px', fontSize: 13 }} value={row.role} onChange={e => setDj(i, 'role', e.target.value)}>
                      {ROLES.map(r => <option key={r} value={r}>{r}</option>)}
                    </select>
                    <input className="lb-input" style={{ padding: '10px 12px', fontSize: 13 }} placeholder="02:00" value={row.time} onChange={e => setDj(i, 'time', e.target.value)} />
                    <button className="lb-iconbtn" onClick={() => rmDj(i)}>✕</button>
                  </div>
                ))}
                <button className="lb-btn lb-btn--ghost lb-btn--sm" style={{ alignSelf: 'flex-start' }} onClick={addDj}>+ Agregar DJ</button>
              </div>
            </div>

            <div style={{ display: 'flex', alignItems: 'center', gap: 14, paddingTop: 4 }}>
              <span className="lb-eyebrow">Estado</span>
              <Toggle on={f.published} onClick={() => set('published', !f.published)} label={f.published ? 'Publicado' : 'Oculto'} />
            </div>
          </div>

          {/* flyer */}
          <div>
            <div className="lb-label" style={{ marginBottom: 10 }}>Flyer</div>
            <label style={{ display: 'block', width: '100%', aspectRatio: '1/1', border: '1px dashed var(--border)', borderRadius: 4, background: f.flyer_url ? `center/cover no-repeat url(${f.flyer_url})` : 'var(--ink-050)', cursor: 'pointer', position: 'relative' }}>
              <input type="file" accept="image/*" onChange={onFlyer} style={{ display: 'none' }} />
              {!f.flyer_url && (
                <div style={{ position: 'absolute', inset: 0, display: 'grid', placeItems: 'center', color: 'var(--ink-600)', fontSize: 12, textAlign: 'center', padding: 20 }}>
                  Subí el flyer<br />(imagen cuadrada 1:1)
                </div>
              )}
            </label>
          </div>
        </div>

        {err && <div style={{ padding: '0 28px', color: 'var(--red-300)', fontSize: 13 }}>{err}</div>}

        <div style={{ padding: '18px 28px', borderTop: '1px solid rgba(255,255,255,0.08)', display: 'flex', gap: 12, justifyContent: 'flex-end' }}>
          <button className="lb-btn lb-btn--ghost lb-btn--sm" onClick={onClose}>Cancelar</button>
          <button className="lb-btn lb-btn--primary lb-btn--sm" onClick={save} disabled={saving}>{saving ? 'Creando…' : 'Crear evento'}</button>
        </div>
      </div>
    </div>
  );
}

function Field({ label, children }) {
  return (
    <div className="lb-field">
      <div className="lb-label">{label}</div>
      {children}
    </div>
  );
}
